import { getlocalStorageLogin } from "common/components/apiConfig";
import { dateMiladiToShamsi } from "common/method/date";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes as member } from "redux/clubMember/clubmember_select";
import { BoxStyled } from "styledComponents/component";
import Password from "./../password";
import { BankAccountForm } from "pages/createBankAccount";
import LazySection from "common/lazySection";

const ProfileModule = () => {
  const dispatch = useDispatch();

  const clubMember = useSelector((state) => state.clubmember_Select);
  const adminObj = getlocalStorageLogin();

  const [clubMemberState, setclubMemberState] = useState({});

  // useEffect(() => {
  // 	setuser(adminObj.user); // Assuming 'adminObj' has a 'user' property
  // }, [adminObj]);

  // Effect to perform some action when 'user' state changes
  useEffect(() => {
    if (adminObj?.user.member_id) {
      // Check if 'user' object and 'member_id' property exist
      let data = {
        _id: adminObj?.user.member_id,
      };
      // Dispatch an action using 'dispatch' function (assuming 'dispatch' is available in your component)
      // Dispatch action to retrieve club member data
      // Assuming 'member.clubmemberSelectAsync' is the action type
      dispatch({
        type: member.clubmemberSelectAsync,
        payload: { data: data },
      });
    }
  }, [adminObj?.user.member_id]);
  // useEffect(() => {
  // 	if (userLocal) {
  // 		setuser(userLocal?.user);
  // 	}
  // }, [userLocal]);
  // useEffect(() => {
  // 	if (user) {
  // 		if (Object.keys(user)?.length !== 0) {
  // 			let data = {
  // 				_id: user.member_id,
  // 			};
  // 			dispatch({
  // 				type: member.clubmemberSelectAsync,
  // 				payload: { data: data },
  // 			});
  // 		}
  // 	}
  // }, [user]);

  useEffect(() => {
    if (clubMember?.data?.results?.length) {
      setclubMemberState(clubMember?.data.results[0]?.body);
    }
  }, [clubMember.data]);

  return (
    <>
      <LazySection>
        <BoxStyled>
          <h1 className="pr-3 mb-3 mt-2 text-[#646464] text-lg">
            اطلاعات شخصی
          </h1>
          <div className="grid grid-cols-12 mt-5">
            <div className="col-span-12 lg:col-span-5">
              {dataRight?.map((rtl, ind) => (
                <div
                  key={ind}
                  className="W-full flex flex-col md:flex-row mb-4 md:items-center"
                >
                  <div className="pr-0 md:pr-10 text-sm ml-28 md:w-[150px] w-full whitespace-nowrap">
                    {rtl.title}
                  </div>
                  <div className="w-full md:w-[350px] bg-[#f9f9f9] rounded-lg h-[50px] text-gray-400 flex items-center pr-2">
                    {rtl.type === "date" &&
                      dateMiladiToShamsi(
                        clubMemberState[rtl.fild]
                          ? clubMemberState[rtl.fild]?.split(" ")[0]
                          : ""
                      )}
                    {rtl.type !== "date" && clubMemberState[rtl.fild]
                      ? clubMemberState[rtl.fild]
                        ? clubMemberState[rtl.fild]
                        : ""
                      : ""}
                  </div>
                </div>
              ))}
            </div>
            <div className="col-span-1 hidden lg:block"></div>
            <div className="col-span-12 lg:col-span-5">
              {dataLeft?.map((rtl, ind) => (
                <div
                  key={ind}
                  className="W-full flex flex-col md:flex-row mb-4 md:items-center"
                >
                  <div className="pr-0 md:pr-10 text-sm ml-28 md:w-[150px] w-full whitespace-nowrap">
                    {rtl.title}
                  </div>
                  <div className="w-full md:w-[350px] lg:w-[200px] xl:w-[330px] 2xl:w-[380px] bg-[#f9f9f9] rounded-lg h-[50px] text-gray-400 flex items-center pr-2">
                    {rtl.type === "date" &&
                      dateMiladiToShamsi(
                        clubMemberState[rtl.fild]
                          ? clubMemberState[rtl.fild]?.split(" ")[0]
                          : ""
                      )}
                    {rtl.type !== "date" && (
                      <>
                        {clubMemberState[rtl.fild] &&
                        clubMemberState[rtl.fild] !== "null"
                          ? clubMemberState[rtl.fild]
                            ? clubMemberState[rtl.fild]
                            : ""
                          : "_"}
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </BoxStyled>
      </LazySection>
      <LazySection entry="slide-down">
        <BoxStyled minHeight={200}>
          <h1 className="pr-3 mb-3 mt-2 text-[#646464] text-lg ">کد بورسی</h1>
          <div className="grid grid-cols-12 mt-5 tourguide-profile-first-step">
            <div className="col-span-12 lg:col-span-5">
              {dataBourseRight.map((rtl, ind) => (
                <div
                  key={ind}
                  className="W-full flex flex-col md:flex-row mb-4 md:items-center"
                >
                  <div className="pr-0 md:pr-10 text-sm ml-28 md:w-[150px] w-full whitespace-nowrap">
                    {rtl.title}
                  </div>
                  <div className="w-full md:w-[350px] lg:w-[200px] xl:w-[330px] 2xl:w-[380px] bg-[#f9f9f9] rounded-lg h-[50px] text-gray-400 flex items-center pr-2">
                    {clubMemberState[rtl.fild] === "null" && "_"}
                    {clubMemberState[rtl.fild] &&
                    clubMemberState[rtl.fild] !== "null"
                      ? clubMemberState[rtl.fild]
                      : ""}
                  </div>
                </div>
              ))}
            </div>
            <div className="col-span-1 hidden lg:block"></div>
            <div className="col-span-12 lg:col-span-5">
              {dataBourseLeft.map((rtl, ind) => (
                <div
                  key={ind}
                  className="W-full flex flex-col md:flex-row mb-4 md:items-center"
                >
                  <div className="pr-0 md:pr-10 text-sm ml-28 md:w-[150px] w-full whitespace-nowrap">
                    {rtl.title}
                  </div>
                  <div className="w-full md:w-[350px] lg:w-[200px] xl:w-[330px] 2xl:w-[380px] bg-[#f9f9f9] rounded-lg h-[50px] text-gray-400 flex items-center pr-2">
                    {clubMemberState[rtl.fild] === "null" && "_"}
                    {clubMemberState[rtl.fild] &&
                    clubMemberState[rtl.fild] !== "null"
                      ? clubMemberState[rtl.fild]
                      : ""}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </BoxStyled>
      </LazySection>
      <LazySection entry="flipIn">
        <Password />
      </LazySection>
    </>
  );
};

export default ProfileModule;

let dataRight = [
  {
    title: "نام",
    fild: "first_name",
  },
  {
    title: "نام خانوادگی",
    fild: "last_name",
  },
  {
    title: "تلفن همراه",
    fild: "phone",
  },
  {
    title: "تاریخ تولد",
    fild: "birth_date",
    type: "date",
  },
];

let dataLeft = [
  {
    title: "کد ملی",
    fild: "national_id",
  },
  {
    title: "ایمیل",
    fild: "email",
  },
  {
    title: "شناسه کارگزاری",
    fild: "",
  },
  {
    title: "تاریخ ثبت نام",
    fild: "registration_date",
    type: "date",
  },
  // {
  //   title: "سطح دسترسی",
  //   fild: "permitted_methods",
  // },
];
let dataBourseRight = [
  {
    title: "کد بورسی اوراق",
    fild: "bourse_code",
  },
  {
    title: "کد بورسی انرژی",
    fild: "energy_bourse_code",
  },
];
let dataBourseLeft = [
  {
    title: "کد بورسی کالا",
    fild: "kala_bourse_code",
  },
  {
    title: "کد بورسی آتی",
    fild: "ati_bourse_code",
  },
];
